const floating_navigation_menu_items = document.querySelectorAll('.floating-navigation__menu-item a');
const floating_navigation_menu_bar = document.querySelector('.floating-navigation__menu-bar');
const floating_navigation_menu = document.querySelector('.floating-navigation__menu');
const floating_navigation_menu_list = document.querySelector('.floating-navigation__menu-list');
const menu_rect = floating_navigation_menu.getBoundingClientRect();

let isMoving = false;
let hover = false;


floating_navigation_menu_items.forEach(function(menu_item){
    menu_item.addEventListener('mouseover', function(event){
        const target__menu_item = event.target;
        if(!hover) {
            var menu_left = floating_navigation_menu.getBoundingClientRect().left;
            var positionInfo = target__menu_item.getBoundingClientRect();
            var width = positionInfo.width - 40;
            var left = positionInfo.left - menu_left + 20;
            floating_navigation_menu_bar.style.width = width+'px';
            floating_navigation_menu_bar.style.left = left+'px';
        }     
        hover = true;
    });
    menu_item.addEventListener('mouseleave', function(event){
        hover = false;
    });
});

floating_navigation_menu_list.addEventListener('mousedown', function(e){
    x = e.clientX;
    isMoving = true;
});
floating_navigation_menu_list.addEventListener('mousemove', e => {
    if (isMoving === true) {
        zx = -e.clientX;
        distance = zx+x;
        if(distance > 0){
            floating_navigation_menu_list.style.marginLeft = -distance+'px';
            floating_navigation_menu_bar.style.left = (- distance + 20) +'px';
        }
        
    }
  });
  
window.addEventListener('mouseup', e => {
if (isMoving === true) {
    isMoving = false;
}
});
floating_navigation_menu_list.addEventListener('touchstart', function(event){
});